const API_BASE = '/api'

function getToken() {
  return localStorage.getItem('budget_token')
}

function setToken(token) {
  if (token) {
    localStorage.setItem('budget_token', token)
  } else {
    localStorage.removeItem('budget_token')
  }
}

async function request(path, options = {}) {
  const token = getToken()
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  })

  const contentType = response.headers.get('content-type') || ''
  if (!contentType.includes('application/json')) {
    if (response.status === 404) throw new Error('Route non trouvée')
    throw new Error(`Erreur serveur (${response.status})`)
  }

  const data = await response.json()

  if (!response.ok) {
    throw new Error(data.error || 'Erreur serveur')
  }

  return data
}

export const api = {
  // Auth
  requestOTP: (phone) => request('/auth/request-otp', { method: 'POST', body: JSON.stringify({ phone }) }),
  verifyOTP: (phone, code) => request('/auth/verify-otp', { method: 'POST', body: JSON.stringify({ phone, code }) }),
  register: (phone, name) => request('/auth/register', { method: 'POST', body: JSON.stringify({ phone, name }) }),
  getMe: () => request('/auth/me'),
  logout: () => request('/auth/logout', { method: 'POST' }),

  // Categories
  getCategories: () => request('/categories'),
  createCategory: (data) => request('/categories', { method: 'POST', body: JSON.stringify(data) }),

  // Budgets
  getBudgets: (month) => request(`/budgets${month ? `?month=${month}` : ''}`),
  setBudget: (data) => request('/budgets', { method: 'POST', body: JSON.stringify(data) }),
  updateBudget: (data) => request('/budgets', { method: 'PUT', body: JSON.stringify(data) }),
  deleteBudget: (id) => request(`/budgets?id=${id}`, { method: 'DELETE' }),

  // Expenses
  getExpenses: (month) => request(`/expenses${month ? `?month=${month}` : ''}`),
  addExpense: (data) => request('/expenses', { method: 'POST', body: JSON.stringify(data) }),
  updateExpense: (data) => request('/expenses', { method: 'PUT', body: JSON.stringify(data) }),
  deleteExpense: (id) => request(`/expenses?id=${id}`, { method: 'DELETE' }),

  // Projects
  getProjects: (status) => request(`/projects${status ? `?status=${status}` : ''}`),
  addProject: (data) => request('/projects', { method: 'POST', body: JSON.stringify(data) }),
  updateProject: (data) => request('/projects', { method: 'PUT', body: JSON.stringify(data) }),
  deleteProject: (id) => request(`/projects?id=${id}`, { method: 'DELETE' }),

  // Groceries
  getGroceries: (filter) => request(`/groceries${filter ? `?filter=${filter}` : ''}`),
  addGrocery: (data) => request('/groceries', { method: 'POST', body: JSON.stringify(data) }),
  updateGrocery: (data) => request('/groceries', { method: 'PUT', body: JSON.stringify(data) }),
  deleteGrocery: (id) => request(`/groceries?id=${id}`, { method: 'DELETE' }),

  // Dashboard
  getDashboard: (month) => request(`/dashboard${month ? `?month=${month}` : ''}`),

  // History
  getHistory: (months) => request(`/history${months ? `?months=${months}` : ''}`),

  // Settings
  getSettings: () => request('/settings'),
  updateSettings: (data) => request('/settings', { method: 'PUT', body: JSON.stringify(data) }),

  // Payments (cahier de suivi)
  getPayments: (month) => request(`/payments${month ? `?month=${month}` : ''}`),
  getPaymentHistory: (categoryId) => request(`/payments/history${categoryId ? `?category_id=${categoryId}` : ''}`),
  recordPayment: (data) => request('/payments', { method: 'POST', body: JSON.stringify(data) }),

  // WebAuthn (biometric signatures)
  beginWebAuthnRegistration: (signerName) => request(`/webauthn/register/begin?signer_name=${encodeURIComponent(signerName)}`),
  completeWebAuthnRegistration: (data) => request('/webauthn/register/complete', { method: 'POST', body: JSON.stringify(data) }),
  getSigners: () => request('/webauthn/signers'),
  deleteSigner: (id) => request(`/webauthn/signers?id=${id}`, { method: 'DELETE' }),

  // Users (superadmin)
  getUsers: () => request('/auth/users'),

  // Presence / Activity
  updatePresence: (route) => request('/presence', { method: 'POST', body: JSON.stringify({ route }) }),
  getPresence: () => request('/presence'),

  // Events (Option B real-time)
  getEvents: (since) => request(`/events${since ? `?since=${encodeURIComponent(since)}` : ''}`),

  // Token management
  setToken,
  getToken,
}
